import React from 'react'
import { makeMobileNavItem } from './styled'
import PropTypes from 'prop-types'

export const RawMobileNavItem = makeMobileNavItem('div')

function MobileNavItem(props) {
  return (
    <RawMobileNavItem {...props}>
      {props.line ? <div className='line' /> : null}
      <a href={props.path} className={props.header ? 'mobileNavHeader' : null}>
        {props.name}
      </a>
    </RawMobileNavItem>
  )
}

MobileNavItem.propTypes = {
  line: PropTypes.bool,
  path: PropTypes.string,
  header: PropTypes.bool,
  name: PropTypes.string,
}

export default MobileNavItem
